module.exports = __webpack_public_path__ + "static/img/ent-detail-89.5c3fb3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-89.jpg
// module id = 2ifc
// module chunks = 52